import React from "react";

function FallbackLoader({
    height = "100%",
    width = "100%",
    text = "Loading...",
}) {
    return (
        <div
            style={{
                width,
                height,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <h>{text}</h>
        </div>
    );
}

export default FallbackLoader;
